import { useCallback, useState } from 'react';

import { TableSortValue } from '../types';
import { setUrlParameters, stringifySort } from '../utils';

export function useSort<I extends EntityBase = EntityBase>({ initial, ignoreQuery }: { 
  initial?: TableSortValue<I>,
  ignoreQuery?: boolean
}) {
  const [_sort, _setSort] = useState<TableSortValue<I>>(() => {
    if (ignoreQuery) {
      return initial || { name: 'id', direction: 'asc' as 'asc' | 'desc' };
    }
    const query = new URLSearchParams(window.location.search);
    const sortValue = query.get('sort');

    const sort = initial || { name: 'id', direction: 'asc' as 'asc' | 'desc' };
    if (sortValue) {
      sort.direction = sortValue.startsWith('+') ? 'asc' : 'desc';
      sort.name = sortValue.substring(1);
    }
    
    return sort;
  });

  const setSort = useCallback((sort: TableSortValue<I>) => {
    _setSort(sort);
    if (!ignoreQuery) { 
      setUrlParameters({
        sort: stringifySort<I>(sort)
      });
    } 
  }, [ignoreQuery]);

  return {
    sort: _sort,
    setSort
  };
}
